<template>
    <div class="wrapper wrapper-content">
        <help-modal/>
        <summary-analyze-box
            :mode="mode"
        :summary-config="summaryConfig"
        :buySummary="buySummary"
        :sellSummary="sellSummary">

        </summary-analyze-box>
        <sell-table v-if="mode == 'standard'"
        :sellSummary="sellSummary">

        </sell-table>
        <buy-table
            :buySummary="buySummary"
            v-if="mode == 'standard'">

        </buy-table>
    </div>
</template>

<script>
import SummaryAnalyzeBox from "./SummaryAnalyzeBox";
import SellTable from "./SellTable";

export default {
    name: "SummaryAnalyze",
    components: {SellTable, SummaryAnalyzeBox},
    props:{
        sellSummary:{
            type:Object
        },
        buySummary:{
            type:Object
        },
        mode:{
            type:String,
            default:"standard"
        }
    },
    data: function () {
        return {
            summaryConfig:{
                include_sell_document_count:1,
                sell_value_in_base_currency_net : true,
                sell_value_in_base_currency_gross : false,
                buy_value_in_base_currency_net : true,
                buy_value_in_base_currency_gross : false,
                buy_value_in_base_currency_net_and_vat : false,
                include_correction:1,
                period:12
            }
        }
    },
}
</script>

<style scoped>

</style>
